import React from 'react';
import { WidgetArrow } from '../../../../../../Icons/dist';
import { WithTranslations, withTranslations } from '../../../../../../utils/withTranslations';
import { TranslationKey } from '../../../../../../i18n/i18n';
import s from './WidgetFeatureListItem.scss';

interface WidgetFeatureProps extends WithTranslations {
  number: number;
  title: TranslationKey;
  onClick: (e?: React.MouseEvent) => void;
}

const WidgetFeatureListItemCmp: React.FC<WidgetFeatureProps> = ({ onClick, number, title, t }) => (
  <div className={s.feature} onClick={onClick}>
    {number}.&nbsp;<span className={s.title}>{t(title)}</span>
    <WidgetArrow className={s.arrowIcon} />
  </div>
);

export const WidgetFeatureListItem = withTranslations(WidgetFeatureListItemCmp);
